import * as React from 'react';
import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import i18n from '@i18next/i18n';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { FOOTER, TITLE, NUMBER, DATE, BODY } from '@src/slide/domain/ui-model/constant/place-holder';

const layoutCheckBoxOptions = [
    {
        label: i18n.t('标题'),
        value: TITLE,
    },
    {
        label: i18n.t('日期'),
        value: DATE,
    },
    {
        label: i18n.t('页脚'),
        value: FOOTER,
    },
    {
        label: i18n.t('页码'),
        value: NUMBER,
    },
];
const masterCheckBoxOptions = [...layoutCheckBoxOptions];
masterCheckBoxOptions.splice(1, 0, {
    label: i18n.t('文本'),
    value: BODY,
});

@Feature()
export class PlaceholderFormatFeature extends BaseDrawerFeature {
    public getPlaceholderFormatContent(): React.ReactElement {
        return (
            <Checkbox.Group
                style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}
                itemStyle={{ fontSize: '12px', paddingBottom: '10px', lineHeight: '18px' }}
                values={this.placeholderCheckedArr()}
                onChange={this.handleChange}
                options={this.getCheckboxOptions()}
            />
        );
    }

    private getCheckboxOptions() {
        return this.getSelectionService()
            .currentSlide?.isMaster ? masterCheckBoxOptions : layoutCheckBoxOptions;
    }

    private placeholderCheckedArr() {
        const info = this.getSelectionService().currentSlide?.childrenPlaceholderInfo || {};
        const checkedArr: string[] = [];
        info.hasTitle && checkedArr.push(TITLE);
        info.hasBody && checkedArr.push(BODY);
        info.hasDate && checkedArr.push(DATE);
        info.hasFooter && checkedArr.push(FOOTER);
        info.hasSlideNum && checkedArr.push(NUMBER);
        return checkedArr;
    }

    private handleChange = (values: string[], e) => {
        const { value, checked } = e.target;
        this.updateProps(ActionType.PLACEHOLDER_FORMAT, { values, value, checked });
    };
}
